import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import VerificationForm from '../../components/VerificationForm/VerificationForm';
import Newslatter from '../../components/Newslatter/Newslatter';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

const VerificationPage = () => {
    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={'Verification'} pagesub={'Verification'} />
            <VerificationForm />
            <Newslatter />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default VerificationPage;

